import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
    IconButton,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import { ModalClose } from "../../assets/icons";


interface BuyLicenseModalProps {
    open: boolean;
    onClose: () => void;
}

const itemStyle = {
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 24px",
    borderBottom: "1px solid #E8EAF0",
};

const BuyLicense: React.FC<BuyLicenseModalProps> = ({ open, onClose }) => {
    const [countEasywebinar, setCountEasywebinar] = useState(0);
    const [countCRM, setCountCRM] = useState(0);

    // to hide the easyCRM  
    const [isEasyCRM, setIsEasyCRM] = React.useState(false);

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                className="cancel-account-dialog"
                sx={{
                    "& .MuiDialog-paper": {
                        maxWidth: "648px",
                        width: "100%",
                        borderRadius: "16px",
                        position: "relative",
                        overflow: "auto",
                    },
                }}
            >
                <DialogTitle sx={{ mb: "32px" }} p={{ xs: "16px 16px 15px !important" }} borderBottom="1px solid #E8EAF0">
                    <Typography color='#333333' fontSize="min(24px, calc(20px + 4 * ((100vw - 320px) / (1920 - 320))))" fontWeight='500'>Buy License</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={() => ({
                            position: 'absolute',
                            right: { xs: "17px" },
                            top: { xs: "15px" },

                        })}
                    >
                        <ModalClose></ModalClose>
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ marginTop: {}, overflow: "unset", px: "16px", pb: "0" }}>
                    <Typography color="#333" fontSize="14px" fontWeight="500" marginBottom="12px">
                        Please choose a license to buy
                    </Typography>
                    <Box display="flex" gap="16px" marginBottom="16px" flexWrap="wrap">
                        <Box display="flex" alignItems="center" gap={2} width={{ xs: "100%", sm: "unset" }}>
                            <Box display="flex" alignItems="start" flexWrap="wrap" maxWidth={{ xs: "100%", sm: "284px" }} width={{ xs: "100%", sm: "284px" }} justifyContent="space-between" borderRadius="12px" border={countEasywebinar > 0 ? "1px solid transparent" : "1px solid #0000003b"} padding="18px" className="card" boxShadow={countEasywebinar > 0 ? "0 0 0 2px #178EFC" : ""} sx={{ "&:hover": { border: countEasywebinar > 0 ? "" : "1px solid #000" } }}>
                                <Box>
                                    <img src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/EasyWebinarLogo.svg" alt="easywebinar-logo" />
                                    <Typography color="#00053D" fontSize="22px" fontWeight="700" display="flex" alignItems="baseline">$40 <Typography color="#666487" fontSize="12px" marginLeft="4px">/account</Typography></Typography>
                                </Box>
                                <Box display="flex" alignItems="center" sx={{ borderRadius: '8px', bgcolor: '#F6F6F6', boxShadow: 'none', p: '4px' }}>
                                    <IconButton
                                        color="primary"
                                        onClick={() => setCountEasywebinar((prev) => (prev > 0 ? prev - 1 : 0))}
                                        sx={{
                                            height: "28px",
                                            width: "28px",
                                            background: "#FFF",
                                            boxShadow: "0px 3px 10px 0px rgba(71, 71, 71, 0.08)",
                                            borderRadius: "6px",
                                            "&:hover": { background: "#FFF" }
                                        }}
                                    >
                                        <Box display="flex" alignItems="center" justifyContent="center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10Z" fill={countEasywebinar > 0 ? "#202032" : "#9B9B9B"} />
                                            </svg>
                                        </Box>
                                    </IconButton>
                                    <Typography mx="14px" sx={{ color: '#081C2B', fontSize: '14px' }}>
                                        {countEasywebinar}
                                    </Typography>
                                    <IconButton
                                        color="primary"
                                        onClick={() => setCountEasywebinar(countEasywebinar + 1)}
                                        sx={{
                                            height: "28px",
                                            width: "28px",
                                            background: "#FFF",
                                            boxShadow: "0px 3px 10px 0px rgba(71, 71, 71, 0.08)",
                                            borderRadius: "6px",
                                            "&:hover": { background: "#FFF" }
                                        }}
                                    >
                                        <Box display="flex" alignItems="center" justifyContent="center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.375C10.1658 4.375 10.3247 4.44085 10.4419 4.55806C10.5592 4.67527 10.625 4.83424 10.625 5V9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H10.625V15C10.625 15.1658 10.5592 15.3247 10.4419 15.4419C10.3247 15.5592 10.1658 15.625 10 15.625C9.83424 15.625 9.67527 15.5592 9.55806 15.4419C9.44085 15.3247 9.375 15.1658 9.375 15V10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H9.375V5C9.375 4.83424 9.44085 4.67527 9.55806 4.55806C9.67527 4.44085 9.83424 4.375 10 4.375Z" fill="#202032" />
                                            </svg>
                                        </Box>
                                    </IconButton>
                                </Box>
                            </Box>
                        </Box>
                        {isEasyCRM && <Box display="flex" alignItems="center" gap={2} width={{ xs: "100%", sm: "unset" }}>
                            <Box display="flex" alignItems="start" flexWrap="wrap" maxWidth={{ xs: "100%", sm: "284px" }} width={{ xs: "100%", sm: "284px" }} justifyContent="space-between" borderRadius="12px" border={countCRM > 0 ? "1px solid  transparent" : "1px solid #0000003b"} padding="18px" className="card" boxShadow={countCRM > 0 ? "0 0 0 2px #178EFC" : ""} sx={{ "&:hover": { border: countCRM > 0 ? "" : "1px solid #000" } }}>
                                <Box>
                                    <img src="https://easywebinar-site.s3.us-east-1.amazonaws.com/images/autheticator-app-images/EasyCrmLogo.svg" alt="easy-crm-logo" />
                                    <Typography color="#00053D" fontSize="22px" fontWeight="700" display="flex" alignItems="baseline">$40 <Typography color="#666487" fontSize="12px" marginLeft="4px">/User</Typography></Typography>
                                </Box>
                                <Box display="flex" alignItems="center" sx={{ borderRadius: '8px', bgcolor: '#F6F6F6', boxShadow: 'none', p: '4px' }}>
                                    <IconButton
                                        color="primary"
                                        onClick={() => setCountCRM((prev) => (prev > 0 ? prev - 1 : 0))}
                                        sx={{
                                            height: "28px",
                                            width: "28px",
                                            background: "#FFF",
                                            boxShadow: "0px 3px 10px 0px rgba(71, 71, 71, 0.08)",
                                            borderRadius: "6px",
                                            "&:hover": { background: "#FFF" }
                                        }}
                                    >
                                        <Box display="flex" alignItems="center" justifyContent="center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10Z" fill={countCRM > 0 ? "#202032" : "#9B9B9B"} />
                                            </svg>
                                        </Box>
                                    </IconButton>
                                    <Typography mx="14px" sx={{ color: '#081C2B', fontSize: '14px' }}>
                                        {countCRM}
                                    </Typography>
                                    <IconButton
                                        color="primary"
                                        onClick={() => setCountCRM(countCRM + 1)}
                                        sx={{
                                            height: "28px",
                                            width: "28px",
                                            background: "#FFF",
                                            boxShadow: "0px 3px 10px 0px rgba(71, 71, 71, 0.08)",
                                            borderRadius: "6px",
                                            "&:hover": { background: "#FFF" }
                                        }}
                                    >
                                        <Box display="flex" alignItems="center" justifyContent="center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.375C10.1658 4.375 10.3247 4.44085 10.4419 4.55806C10.5592 4.67527 10.625 4.83424 10.625 5V9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H10.625V15C10.625 15.1658 10.5592 15.3247 10.4419 15.4419C10.3247 15.5592 10.1658 15.625 10 15.625C9.83424 15.625 9.67527 15.5592 9.55806 15.4419C9.44085 15.3247 9.375 15.1658 9.375 15V10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H9.375V5C9.375 4.83424 9.44085 4.67527 9.55806 4.55806C9.67527 4.44085 9.83424 4.375 10 4.375Z" fill="#202032" />
                                            </svg>
                                        </Box>
                                    </IconButton>
                                </Box>
                            </Box>
                        </Box>}
                    </Box>
                    <Box marginBottom="24px">
                        <Typography color=" #333" fontSize="16px" fontWeight="500" marginBottom="28px">
                            Summary
                        </Typography>
                        <Box
                            sx={{
                                border: "1px solid #E8EAF0",
                                borderRadius: 2,
                                overflow: "hidden",
                            }}
                        >
                            <Box sx={itemStyle}>
                                <Typography color="#000" fontSize="16px" fontWeight="500">EasyWebinar License</Typography>
                                <Typography color="#A3A3A3" fontSize="16px" display="flex" fontWeight="500" alignItems="center">$40 x <Typography color="#333" fontSize="18px">1</Typography></Typography>
                            </Box>
                            {isEasyCRM && <Box sx={itemStyle}>
                                <Typography color="#000" fontSize="16px" fontWeight="500">EasyCRM License</Typography>
                                <Typography color="#A3A3A3" fontSize="16px" display="flex" fontWeight="500" alignItems="center">$25 x <Typography color="#333" fontSize="18px">1</Typography></Typography>
                            </Box>}
                            <Box sx={itemStyle}>
                                <Typography color="#000" fontSize="16px" fontWeight="500">Tax</Typography>
                                <Typography color="#333" fontSize="18px" fontWeight="500">$0.00</Typography>
                            </Box>
                            <Box sx={{ ...itemStyle, backgroundColor: "#E7F3FF", borderBottom: "none" }}>
                                <Typography color="#000" fontSize="16px" fontWeight="500">Total</Typography>
                                <Typography color="#333" fontSize="18px" fontWeight="500">$65.00</Typography>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ mb: { xs: "16px", sm: "32px" }, mr: { xs: "11px", sm: "32px" } }}>
                    <Button color="primary" sx={{
                        border: '1px solid #E8EAF0', px: '22px', color: '#2B2B30 !important', textTransform: 'capitalize', borderRadius: '8px', mr: '16px', '&:hover': {
                            border: '1px solid #E8EAF0 !important',
                            boxShadow: 'unset !important'
                        },
                    }}>
                        Cancel
                    </Button>
                    <Button sx={{
                        textTransform: 'capitalize', bgcolor: '#178EFC', color: '#FFFFFF !important', px: '24px', height: '40px', borderRadius: '8px', '&:hover': {
                            boxShadow: 'none !important',
                        },
                    }}>Buy Now</Button>
                </DialogActions>
            </Dialog >
        </>
    );
};
export default BuyLicense;



